export const ONESTEP_AGENT_IN_PORTAL_FLAG = 'onestep-agent-in-portal';
